import React from 'react';
import { LoanDrawPanel } from '../../components/LoanDrawPanel/LoanDrawPanel';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { useAuthenticationStore } from '../../../../state/authenticationStore';

interface IDashboardParameters {
    dashboardDrawBudgets: IDashboardDrawBudget[] | undefined;
    loading: boolean;
}

export const MobileDashboard: React.FC<IDashboardParameters> = ({ dashboardDrawBudgets, loading }) => {
    const selectedAuthorizedDrawUserEntity = useAuthenticationStore((s) => s.selectedEntity);
    return (
        <div className='content'>
            <div className='contentSection full'>
                <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
                    <h1>{selectedAuthorizedDrawUserEntity?.name}</h1>
                    <LoanDrawPanel
                        dashboardDrawBudgets={dashboardDrawBudgets}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};
